import { useCallback } from "react";
import { trackClick, trackEvent } from "@utils/analytics";

interface UseAnalyticsReturn {
    trackButtonClick: (
        buttonName: string,
        context?: Record<string, string | number | boolean | undefined>
    ) => void;
    trackCustomEvent: (
        eventName: string,
        params?: Record<string, string | number | boolean | undefined>
    ) => void;
}

/**
 * Hook for tracking user interactions with Google Analytics
 * 
 * Usage:
 * const { trackButtonClick } = useAnalytics();
 * 
 * <button onClick={() => trackButtonClick("enter_raffle", { raffle_id: 123 })}>
 *   Enter Raffle
 * </button>
 */
export const useAnalytics = (): UseAnalyticsReturn => {
    const trackButtonClick = useCallback(
        (buttonName: string, context?: Record<string, string | number | boolean | undefined>) => {
            trackClick(buttonName, context);
        },
        []
    );

    const trackCustomEvent = useCallback(
        (eventName: string, params?: Record<string, string | number | boolean | undefined>) => {
            trackEvent(eventName, params);
        },
        []
    );

    return {
        trackButtonClick,
        trackCustomEvent,
    };
};

export default useAnalytics;
